export default __webpack_public_path__ + "static/media/Girdle of the Chaos Agent.eb15bba7.jpg";